import { Button } from '@mm/components';
import { landmineNames } from '@mm/constants/landmine-names';
import { OmnisendIcon } from '@mm/icons';
import { selectCrmsLeadsSent } from '@mm/state/selectors/connectionsSelectors';
import React, { useEffect } from 'react';
import { ButtonColor } from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { BaseIntegration } from '../../../BaseIntegration/BaseIntegration';
import { BaseIntegrationHeader } from '../../../BaseIntegration/BaseIntegrationHeader';
import { useFetchConnections } from '../../../use-fetch-connections';
import { useSelector } from 'react-redux';
import { TeamOutlined } from '@ant-design/icons';
import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';
import { OmnisendSettings } from './OmnisendSettings';

const header = (leadsSent?: number) => (
  <div className="integrations__header-actions">
    {!!leadsSent && (
      <div className="integrations__header-status">
        <TeamOutlined className="integrations__header-status-icon" />
        <div className="integrations__header-status-count">{leadsSent}</div>
        Leads sent
      </div>
    )}
    <Button
      css={{ container: 'integrations__header-add-button-secondary' }}
      onClick={e => {
        e?.stopPropagation();
        window.open('https://app.omnisend.com/api', '_blank');
      }}
      color={ButtonColor.secondaryBlue}
    >
      Add an Account
    </Button>
  </div>
);

export const OmnisendIntegrations = () => {
  const { fetch } = useFetchConnections();

  const sectionProps = {
    landmineName: landmineNames.OMNISEND_UPGRADE,
    featureFlag: 'nativeIntegrations',
  };

  useEffect(() => {
    fetch(1, 200, 'omnisend');
  }, [fetch]);

  const crmsLeadsSent = useSelector(selectCrmsLeadsSent);
  const leadsSent = crmsLeadsSent?.omnisendContactsSent;

  const { companyName = 'Customers.ai' } = useWhitelabelConfig();

  return (
    <BaseIntegration
      openOnMount
      titleComponent={
        <BaseIntegrationHeader
          title="Omnisend"
          upgradeButtonName="Add a Connection"
          subtitle={`Automatically sync your ${companyName} contacts to Omnisend`}
          icon={<OmnisendIcon />}
          headerRightComponent={header(leadsSent)}
          css={{ icon: 'integrations__omnisend-header-icon' }}
          {...sectionProps}
        />
      }
      integrationType="omnisend"
    >
      <OmnisendSettings />
    </BaseIntegration>
  );
};
